export const styles = () => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    minHeight: '100vh',
    width: '100%',
    padding: '2rem 1rem',
  },
  paper: {
    width: '100%',
    maxWidth: '78rem',
    borderRadius: '4px',
    padding: '1rem',
    border: '1px solid #e0e0e0',
    color: '#2D2D2D',
  },
  tableHeaderRegion: {
    '& th': {
      backgroundColor: '#fff',
    },
  },
  fixedTableLayout: {
    width: '100%',
    tableLayout: 'fixed',
  },
  // Keep semantic table headers available to assistive tech without adding
  // a second visible header row in the scrollable body table.
  srOnlyTableHead: {
    position: 'absolute',
    width: 1,
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    border: 0,
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    whiteSpace: 'nowrap',
    '& tr': {
      height: 0,
    },
    '& th': {
      border: 0,
      padding: 0,
      height: 0,
      lineHeight: 0,
      fontSize: 0,
    },
  },
  tableScrollRegion: {
    position: 'relative',
    height: 'min(60vh, 32rem)',
    overflowY: 'auto',
    overflowX: 'hidden',
    scrollbarGutter: 'stable',
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  // Anchor the countdown hint under pagination on the bottom-left of the card.
  sessionHintRow: {
    display: 'flex',
    justifyContent: 'flex-start',
    margin: '0 0 0.75rem',
    paddingLeft: '0.75rem',
  },
  // Keep the hint readable but visually secondary to primary actions.
  sessionHintText: {
    fontSize: '0.8rem',
    color: '#5f6368',
    fontWeight: 500,
  },
  title: {
    fontSize: '1.2rem',
    color: '#1a173b',
  },
  searchField: {
    width: '22rem',
  },
  searchInput: {
    padding: '0.5rem 0',
  },
  searchAdornedStart: {
    paddingLeft: '0.5rem',
  },
  loadingState: {
    height: 'min(60vh, 32rem)',
    textAlign: 'center',
    verticalAlign: 'middle',
    borderBottom: 'none',
  },
  loadingText: {
    marginTop: '1rem',
    color: '#666',
  },
  headerCell: {
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },
  lastUsedCell: {
    whiteSpace: 'nowrap',
  },
  officeCompanyCell: {
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
  },
  // Always show the sort icon on every column header, not just the active one
  sortLabelIcon: {
    opacity: 1,
  },
  actionCell: {
    textAlign: 'right',
    paddingRight: '0.5rem !important',
  },
  loginAsUserButton: {
    whiteSpace: 'nowrap',
    minWidth: '6.75rem',
    padding: '0.2rem 0.45rem',
    fontSize: '0.9rem',
  },
  tableRow: {
    cursor: 'default',
  },
  backButton: {
    display: 'flex',
    margin: '1.25rem auto 0',
    border: 'none',
  },
  noAccountContainer: {
    minHeight: '100vh',
    width: '100%',
    padding: '2rem 0',
  },
  noAccountPaper: {
    width: 'min(40rem, calc(100vw - 2rem))',
    borderRadius: '4px',
    padding: '2rem',
    border: '1px solid #e0e0e0',
    boxSizing: 'border-box',
  },
  noAccountLogo: {
    display: 'block',
    marginBottom: '2rem',
    maxWidth: '18.75rem',
    maxHeight: '3.125rem',
  },
  noAccountIllustration: {
    maxWidth: '12rem',
    marginBottom: '2rem',
  },
  noAccountHeading: {
    fontWeight: 500,
    fontSize: '1.5rem',
    marginBottom: '.6rem',
  },
  noAccountSubheading: {
    fontSize: '1rem',
    color: '#757575',
    marginBottom: '1rem',
  },
  noAccountReasonCode: {
    fontSize: '.75rem',
    color: '#9e9e9e',
    marginBottom: '1rem',
  },
  noAccountBackButton: {
    border: 'none',
  },
});
